import { Injectable } from '@angular/core';

import { ApplicationAdapter } from 'application/application.adapter';
import { ModuleTaskOutput } from 'module/model/page/task/module-task.output';
import { ModuleTask } from 'module/page/task/module-task';
import { ModuleTaskI18n } from 'module/page/task/module-task-i18n';
import { ModuleTaskConverterPort } from 'module/page/task/port/module-task-converter.port';

@Injectable()
export class ModuleTaskConverterAdapter
	extends ApplicationAdapter
	implements ModuleTaskConverterPort
{
	public asModuleTask(output: ModuleTaskOutput): ModuleTask {
		if (!output) {
			return null;
		}

		return new ModuleTask(
			output.id,
			output.type,
			output.position,
			output.updateTimestamp,
			(output.localizations || []).map(
				(loc) =>
					new ModuleTaskI18n(loc.title, loc.locale, loc.category, loc.description)
			)
		);
	}
}
